import { formatOrderDate, formatOrderTime } from "../orders/format";

export const TARGET_TYPES = Object.freeze({
  SUPPLIER: "SAPPHIRE_SUPPLIER",
  PRODUCT: "SAPPHIRE_PRODUCT",
});

const TARGET_LABELS = Object.freeze({
  [TARGET_TYPES.SUPPLIER]: "Supplier",
  [TARGET_TYPES.PRODUCT]: "Product",
});

export const normalizeTargetType = (value) =>
  String(value || "").toUpperCase() === TARGET_TYPES.PRODUCT
    ? TARGET_TYPES.PRODUCT
    : TARGET_TYPES.SUPPLIER;

export const targetTypeLabel = (value) => TARGET_LABELS[normalizeTargetType(value)];

export const asTargetId = (value) => {
  const number = Number(value);

  return Number.isFinite(number) && number > 0 ? number : null;
};

export const mapReview = (dto) => {
  if (!dto) return null;

  const targetType = normalizeTargetType(dto.ratedTargetType);
  const rating = Number(dto.rating);

  return {
    id: dto.id,
    rating: Number.isFinite(rating) ? rating : 0,
    review: dto.review || "",
    active: dto.active !== false,
    targetId: asTargetId(dto.ratedTargetId),
    targetType,
    targetLabel: TARGET_LABELS[targetType],
    authorName: dto.authorName || "",
    createdAt: dto.createdAt || null,
    updatedAt: dto.updatedAt || null,
    createdDate: formatOrderDate(dto.createdAt),
    createdTime: formatOrderTime(dto.createdAt),
  };
};

export const mapReviews = (rows) =>
  (rows || []).map(mapReview).filter((row) => row && row.id != null);

export const findReviewFor = (reviews, { targetType, targetId }) => {
  const type = normalizeTargetType(targetType);
  const id = asTargetId(targetId);

  if (!id) return null;

  return (reviews || []).find((row) => row.targetId === id && row.targetType === type) || null;
};

export const ratingLabel = (rating) => (Number(rating) || 0).toFixed(1);
